import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import type { Locale } from '~/i18n/types'
import { defaultLocale, supportedLocales } from '~/i18n'
import { i18n } from '~/i18n'

// Create routes with locale prefixes
const routesWithLocale = routes.map(route => {
  // Skip if route already has locale prefix
  if (route.path?.startsWith('/:locale')) {
    return route
  }

  return {
    ...route,
    path: `/:locale${route.path || ''}`,
    beforeEnter: (to: any) => {
      const locale = to.params.locale as Locale
      if (!supportedLocales.includes(locale)) {
        return `/${defaultLocale}${to.path.replace(`/${locale}`, '')}`
      }
    }
  }
})

// Add root redirect to default locale
routesWithLocale.unshift({
  path: '/',
  redirect: `/${defaultLocale}`
})

const router = createRouter({
  history: createWebHistory(),
  routes: routesWithLocale,
})

// Navigation guard to set locale
router.beforeEach(async (to, _from, next) => {
  const locale = (to.params as any).locale as Locale
  if (locale && supportedLocales.includes(locale)) {
    // Set locale in i18n
    i18n.global.locale.value = locale
  }
  next()
})

// Hot module replacement is handled automatically by unplugin-vue-router

export default router
